import React, { lazy } from 'react';

import CollectiveDirectoryPersonDrawer from 'app/components/People/PeopleDrawer';
import { PEOPLE_CONTEXT } from 'store/reducers/people/people-reducer';

import usePersonDrawerData from '../hooks/usePersonDrawerData';
import { GlobalPersonDrawerBackArrow } from './styled';

interface GlobalPersonDrawerProps {
  slug?: string;
  comingFromList?: boolean;
  backToListAction?: () => void;
  theme?: 'light' | 'dark';
  children?: React.ReactNode;
  matches?: any[];
  uuid?: string;
}

export default function GlobalPersonDrawer({
  slug,
  uuid,
  comingFromList = false,
  backToListAction = () => {},
  theme = 'light',
  matches = [],
  children = null,
}: GlobalPersonDrawerProps) {
  return (
    <>
      {comingFromList && (
        <GlobalPersonDrawerBackArrow>
          <BackArrow onClick={backToListAction} />
        </GlobalPersonDrawerBackArrow>
      )}
      <CollectiveDirectoryPersonDrawer
        slug={slug}
        uuid={uuid}
        context={PEOPLE_CONTEXT.COLLECTIVE_DIRECTORY}
        matches={matches}
        hideAddActions
        fromGlobalDrawer
      />
    </>
  );
}

export function BackArrow({ onClick }: { onClick?: () => void }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ alignSelf: 'flex-start', cursor: 'pointer' }}
    >
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
        fill="#D9D9D9"
        fillOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.55806 14.8169C9.80214 15.061 10.1979 15.061 10.4419 14.8169C10.686 14.5729 10.686 14.1771 10.4419 13.9331L7.13388 10.625L14.375 10.625C14.7202 10.625 15 10.3452 15 10C15 9.65482 14.7202 9.375 14.375 9.375L7.13388 9.375L10.4419 6.06694C10.686 5.82286 10.686 5.42714 10.4419 5.18306C10.1979 4.93898 9.80214 4.93898 9.55806 5.18306L5.18382 9.55729C5.18118 9.55992 5.17857 9.56258 5.17598 9.56525C5.05866 9.68634 5 9.84317 5 10C5 10.0847 5.01687 10.1655 5.04743 10.2392C5.07671 10.31 5.11956 10.3765 5.17598 10.4347C5.17854 10.4374 5.18113 10.44 5.18374 10.4426M9.55806 14.8169L5.18374 10.4426L9.55806 14.8169Z"
        fill="#1F2025"
      />
    </svg>
  );
}
